import { ref } from "vue";

export default function useMyToDoListAdjust(getList) {
  const adjustRef = ref(null);
  // 点击处理
  const handleDispose = (row) => {
    adjustRef.value?.handleDialogOpen(row.taskId);
  };

  // 点击交还
  const handleReturn = (row) => {};

  return {
    adjustRef,
    handleDispose,
    handleReturn,
  };
}
